﻿

/**
 * PurchasingAgreementStepsComponent
 *
 * @param {string} type             Type (used for filtering out steps)
 * @param {boolean} isInternal      Is internal site flag
 * @param {string?} outerSelector   Find agreement steps within this (jQuery) selector only, optional
 */
export const PurchasingAgreementStepsComponent = function (type, isInternal, outerSelector) {
    var stepsSelector = ".agreement-step";

    this.type = type;
    this.isInternal = isInternal;
    this.outerSelector = outerSelector || null;
    this.$steps = getApplicableSteps.call(this);

    function getApplicableSteps() {
        var $allSteps = this.outerSelector ? $(this.outerSelector).find(stepsSelector) : $(stepsSelector);

        // Filter out steps for internal/external only and specific agreement types only
        return $allSteps.filter(function (i, elStep) {
            var $step = $(elStep);

            if ($step.hasClass('agreement-step__external') && this.isInternal) {
                return false;
            }
            if ($step.hasClass('agreement-step__internal') && !this.isInternal) {
                return false;
            }
            if (elStep.className.indexOf('agreement-step__type-') !== -1) {
                var isForAgreementType = $step.hasClass('agreement-step__type-' + this.type);
                if (!isForAgreementType) {
                    return false;
                }
            }

            return true;
        }.bind(this));
    }
    this.getApplicableSteps = getApplicableSteps.bind(this);

    function getCurrentStepIndex () {
        var currentStepIdx = -1;

        this.$steps.each(function (i, elStep) {
            var $step = $(elStep);

            if (!$step.hasClass('hidden')) {
                currentStepIdx = i;

                return false; // break
            }
        });

        return currentStepIdx;
    }
    this.getCurrentStepIndex = getCurrentStepIndex.bind(this);
};

PurchasingAgreementStepsComponent.prototype.next = function () {
    var currentStepIdx = this.getCurrentStepIndex();
    if (currentStepIdx === -1) {
        throw "Could not find currentStep.";
    }

    this.$steps.addClass('hidden');
    this.$steps.eq(currentStepIdx + 1).removeClass('hidden');
};

PurchasingAgreementStepsComponent.prototype.previous = function () {
    var currentStepIdx = this.getCurrentStepIndex();
    if (currentStepIdx === -1) {
        throw "Could not find currentStep.";
    }

    this.$steps.addClass('hidden');
    this.$steps.eq(currentStepIdx - 1).removeClass('hidden');
};

PurchasingAgreementStepsComponent.prototype.setType = function (type) {
    this.type = type;
    this.$steps = this.getApplicableSteps();
}